import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { Filter, FilterPill } from 'even-ts-static'
const Close = require('./close.svg')

const styles = require('./styles')

export interface Props {
  onRemovePillClick: (filter: Filter) => void
  pillData: FilterPill
}

class Pill extends React.Component<Props> {
  onRemovePillClick = () => {
    this.props.onRemovePillClick(this.props.pillData.filter)
  }

  render() {
    return (
      <ThemeConsumer>
        {({ colorSecondary }) => (
          <div
            data-test-id="filter_pill"
            className={classnames(
              styles.pill,
              css(`
            background: ${colorSecondary};
            &:hover {
              background: ${colorSecondary};
              opacity: 0.84;
            }
          `),
            )}
          >
            {this.props.pillData.label}
            <Close className={styles.closePill} onClick={this.onRemovePillClick}>
              x
            </Close>
          </div>
        )}
      </ThemeConsumer>
    )
  }
}

export default Pill
